import "./Hero.scss";
//import "./Features.scss";
import { IoCloseCircleOutline, IoSearch } from "react-icons/io5";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Songbook } from "../../../@core/models";
import debounce from "lodash/debounce";
import RestClient from "../../../@core/restClient";
import Spinner from "../UI/Spinner";


const Hero = () => {
  const queryRef = useRef<any>();
  const [query, setQuery] = useState<string>("");
  const [selectedSongbookId, setSelectedSongbookId] = useState<number | null>(
    null
  );
  const [songbooks, setSongbooks] = useState<Songbook[]>([]);
  const [filteredSongbooks, setFilteredSongbooks] = useState<any>([]);
  const [boxOpen, setBoxOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [tickerSongs, setTickerSongs] = useState<any[]>([]);

  const navigate = useNavigate();

  // const deferredSetQueryHandler = useCallback(
  //   debounce((event: React.ChangeEvent<HTMLInputElement>) => {
  //     //setQuery(event.target.value);
  //     setFilter(queryRef.current.value);
  //   }, 200),
  //   []
  // );

  const deferredSetQueryHandler = useCallback(
    debounce(
      (event: React.ChangeEvent<HTMLInputElement>, isUserAction: boolean) => {
        if (!isUserAction) return;
        setFilter(queryRef.current?.value || "");
      },
      200
    ),
    []
  );

  // In your input
  //<input onChange={(e) => deferredSetQueryHandler(e, true)} />;

  // FILTER SONG BOOKS
  const filterSongBooks = () => {
    const filtered = songbooks
      .filter((el) => {
        return filter ? el.title.includes(filter) : true;
      })
      .sort((a, b) => a.title.localeCompare(b.title, "uk")); // Add this line
    setFilteredSongbooks(filtered);
    setBoxOpen(true);
  };
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip on first render
    }
    filterSongBooks();
  }, [filter]);

  useEffect(() => {
    (async () => {
      try {
        const songs = await RestClient.getSongListByQuery("", "", true, 1, 30);
        const shuffled = [...songs].sort(() => Math.random() - 0.5);
        setTickerSongs(shuffled);
      } catch {
        // ticker is decorative, fail silently
      }
    })();
  }, []);

  // INITIAL SONGBOOKS QUERY

  useEffect(function () {
    (async () => {
      try {
        //setIsLoading(true);
        const response = await RestClient.getSongbookList("");
        setSongbooks(
          response.sort((a, b) => a.title.localeCompare(b.title, "uk")) || []
        );
        setFilteredSongbooks(
          response.sort((a, b) => a.title.localeCompare(b.title, "uk")) || []
        );
      } catch (error) {
        console.log(error);
      }
    })();
    setIsLoading(false);
  }, []);

  // useEffect(
  //   function () {
  //     setIsLoading(true);
  //     (async () => {
  //       // if (
  //       //   queryRef.current !== document.activeElement ||
  //       //   queryRef.current.value !== query
  //       // ) {
  //       //   return;
  //       // }
  //       try {
  //         const response = await RestClient.getSongbookList(query);
  //         setSongbooks(response || []);
  //         setBoxOpen(true);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     })();
  //     setIsLoading(false);
  //   },
  //   [query]
  // );

  const selectSongbook = (songbook: Songbook) => {
    //queryRef.current.value = songbook.title;
    //setQuery(songbook.title);
    setSelectedSongbookId(songbook.id);
    //setFilteredSongbooks(songbooks);
    setBoxOpen(false);
    queryRef.current.value = "";
    navigate(`/songbook/${songbook.id}`);
    window.scrollTo(0, 0);
    //setQuery("");
  };

  const openBox = () => {
    setBoxOpen(true);
    //setQuery("");
    queryRef.current.value = "";
  };
  const closeBox = () => {
    setBoxOpen(false);
    // setQuery("");
    queryRef.current.value = "";
    setFilteredSongbooks(songbooks);
  };

  return (
    <div className="hero">
      <div className="hero-small-text">Завжди під рукою</div>
      <h1 className="title">
        <span>ARYN Lyrics</span>
        <br />
        Сучасний
        <br />
        організатор пісень
      </h1>
      <div className="choose-book">
        <div className="box-open-btn">
          {isLoading ? <Spinner /> : null}
          {/* <Spinner /> */}
          <IoSearch className="search-icon" />
          <input
            className="box-open-btn-input"
            type="text"
            ref={queryRef}
            placeholder="Знайти пісенник"
            onChange={(e) => deferredSetQueryHandler(e, true)}
          />
          <div className="btn-mcolor show-songbooks" onClick={() => openBox()}>
            Відкрити пісенник
          </div>
          {boxOpen ? (
            <div className="select-container_two">
              <IoCloseCircleOutline
                className="closeBtn"
                onClick={() => {
                  closeBox();
                }}
              />
              {filteredSongbooks.map((songbook: Songbook, index: number) => (
                <div
                  className="select-item_two"
                  key={index}
                  onClick={() => selectSongbook(songbook)}
                >
                  {songbook.title}
                </div>
              ))}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {tickerSongs.length > 0 && (
        <div className="hero-ticker">
          <div className="hero-ticker-track">
            {[...tickerSongs, ...tickerSongs].map((item, i) => (
              <span
                key={i}
                className="hero-ticker-item"
                onClick={() => navigate(`/library/song/${(item as any).id}`)}
              >
                {(item as any).title}
                <span className="hero-ticker-sep">♪</span>
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="hero-img-container">
        <div className="hero-img-group">
          <div className="hero-img-1">
            <img src="/images/home-musician3.jpg" alt="home-musician3" />
          </div>
          <div className="hero-img-2">
            <img src="/images/home-musician4.jpg" alt="home-musician4" />
          </div>
          <div className="hero-img-3">
            <img src="/images/home-band.jpg" alt="home-band" />
          </div>
          <div className="geo-form"></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
